import type { StaticInventoryFile } from '@flexpath/core/src/types/staticInventory-types.d.ts';
import { INVENTORY_URL } from './site-config.ts';

const CACHE_KEY = 'dealer_inv_v2';
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

export async function loadInventory(): Promise<StaticInventoryFile> {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY);
    if (raw) {
      const { ts, data } = JSON.parse(raw) as { ts: number, data: StaticInventoryFile };
      if (Date.now() - ts < CACHE_TTL) return data;
    }
  } catch (_e) { /* cache is best-effort */ }

  const res = await fetch(INVENTORY_URL);
  if (!res.ok) throw new Error(`Inventory fetch failed: ${res.status}`);
  const json = await res.json() as StaticInventoryFile;

  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), data: json }));
  } catch (_e) { /* cache is best-effort */ }

  return json;
}
